// noinspection ES6UnusedImports
import * as React from 'preact/compat'
import Modal from '../components/Modal'
import Sidenote from '../components/Sidenote'
import articleCss from '../../css/article.pcss.json'
import { showModal } from '../common/helpers'

declare global {
  interface HTMLElement {
    abbrViewer?: AbbrViewer
  }
}

const showMobileAbbr = (text: string, title: string, element: HTMLSpanElement) => {
  showModal(({ onClose }) => <Modal showClose onClose={onClose}>
    <p className={articleCss['sidenote-header']}>{title}</p>
    <div className={articleCss['sidenote__inner']} dangerouslySetInnerHTML={{ __html: text }}/>
  </Modal>, {}, () => {
    element.removeAttribute('data-abbr-shown')
  })
}

const showDesktopAbbr = (text: string, title: string, element: HTMLSpanElement) => {
  showModal(({ onClose }) => <Sidenote onClose={onClose} header={title} parentEl={element}>
    <div className={articleCss['sidenote__inner']} dangerouslySetInnerHTML={{ __html: text }}/>
  </Sidenote>, {}, () => {
    element.removeAttribute('data-abbr-shown')
  }, true)
}

const showAbbr = (text: string, title: string, element: HTMLSpanElement) => {
  if (element.hasAttribute('data-abbr-shown')) {
    return
  }
  text = decodeURIComponent(text)
  element.setAttribute('data-abbr-shown', 'true')
  if (window.matchMedia('(max-width: 1220px)').matches) {
    showMobileAbbr(text, title, element)
  } else {
    showDesktopAbbr(text, title, element)
  }
}

class AbbrViewer {
  element: HTMLSpanElement
  text: string
  title: string
  inEditor: boolean

  constructor(element: HTMLSpanElement) {
    this.element = element
    this.text = element.getAttribute('title')
    this.title = element.getAttribute('data-abbr-title') || element.innerText
    this.inEditor = element.closest('.codex-editor') !== null
    if (!this.inEditor) {
      element.removeAttribute('title')
    }
    element.addEventListener('click', (e) => {
      if (this.inEditor && !window.getSelection().isCollapsed) {
        return
      }
      e.preventDefault()
      e.stopPropagation()
      showAbbr(this.text, this.title, element)
    })
    element.abbrViewer = this
  }

  update(title?: string, text?: string) {
    if (!title) {
      title = this.element.getAttribute('data-abbr-title') || this.element.innerText
    }
    if (!text) {
      text = this.element.getAttribute('title')
    }
    this.title = title
    this.text = text
  }
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement
        if (element.tagName === 'ABBR' && element.hasAttribute('title')) {
          new AbbrViewer(element)
        }
      }
    })
  })
})

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach(element => {
    const spans = element.querySelectorAll<HTMLSpanElement>('abbr[title]')
    spans.forEach(span => {
      if (span.hasAttribute('data-abbr-attached')) {
        return
      }
      span.setAttribute('data-abbr-attached', 'true')
      new AbbrViewer(span)
    })
    observer.observe(element, { childList: true, subtree: true })
  })
}
